import DevNoaManagementAppView from "@/views/development/noa/DevNoaManagementAppView.vue";
import DevelopmentSpacesView from "@/views/DevelopmentSpacesView.vue";
import ExamFormDevView from "@/views/development/exam/ExamFormDevView.vue";

export const devRoutes = [
  {
    path: "/spaces-development",
    name: "Simulate DP Spaces Header",
    component: DevelopmentSpacesView,
  },
  {
    path: "/noa-management-app",
    name: "NOA Management App",
    component: DevNoaManagementAppView,
  },
  {
    path: "/dev/exam-form",
    name: "Exam Form Dev",
    component: ExamFormDevView,
  },
];
